// Adisyon Yazdırma Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.receiptSettings';

export const receiptSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Adisyon fişi nasıl ayarlanır?'),
  intro: t(`${G}.intro`, 'Bu pencere fiş yazıcısından çıkan adisyonun (fişin) başlığını, içeriğini, alt notunu ve kağıt ölçülerini belirler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Fiş ayarları'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Fiş başlığını seçin'),
      text: t(`${G}.s1.text`, '"Metin Başlık (Şirket Bilgileri)" seçilirse fişin üstüne Şirket Adı, Vergi Numarası ve Şirket Adresi yazılır. "Logo Başlık" seçilirse "Resim Kütüphanesinden Seç" ile bir logo seçersiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şirket Adı zorunludur. Logo başlıkta bu alan gizlenir ama yine dolu olmalıdır; boşsa önce Metin Başlık\'a geçip doldurun.'),
        t(`${G}.s1.tip2`, 'Logo olarak yalnız resim seçilebilir. 80 mm fiş için genişlik yaklaşık 384 px\'tir; aynı boyut tüm fiş türlerinde kullanılır.'),
        t(`${G}.s1.tip3`, '"Fiş başlık metni/logosu göster" kapalıysa başlık basılmaz; Logo Başlık seçiliyken her zaman açıktır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Fişte neler görünsün?'),
      text: t(`${G}.s2.text`, 'Yazdırma Ayarları bölümünden işaretleyin: "İndirim bilgilerini göster", "Ara Toplam ve KDV Toplam göster", "Kasiyer adı göster". Aynı fişten kaç adet çıkacağını 1–9 arasında girin; boş bırakılırsa 1 adet yazdırılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Fiş numarası'),
      text: t(`${G}.s3.text`, '"Fiş numarası ekle" işaretlenirse her fişe sıra numarası basılır. "Fiş numaraları bu rakamdan sonra sıfırla" alanına 1–999999 arası bir sayı girin; numara bu sayıyı geçince yeniden 1\'den başlar (boşsa 999999). "Gün sonunda sıfırla" işaretliyse her yeni günün ilk fişi 1 numarayla başlar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Fiş numarası sayacı her bilgisayarda ayrı tutulur. Elle sıfırlamak için ayarlar penceresindeki "Fiş No Sıfırla" düğmesini kullanın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Alt bilgi ve fiş formatı'),
      text: t(`${G}.s4.text`, 'Fişin altına basılacak "Standart Not" ve "Teşekkür Mesajı/Slogan" yazın. Fiş Formatı bölümünde kağıt genişliğini (mm), bir satıra sığacak karakter sayısını ve üst, alt, sol, sağ kenar boşluklarını (mm) yazıcınıza göre ayarlayın.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" ayarları bu pencereyi açtığınız ayarlar penceresine aktarır ve kapanır. Kalıcı olması için orada da kaydedin ("Değişiklikleri Kaydet" veya "Yazdırma Ayarlarını Kaydet"). Şirket Adı boşsa "Kaydet" çalışmaz.'),
    },
  ],
});
